<input type="text"
    class="form-control"
    [(ngModel)]="value"
    [ngbTypeahead]="searchTimezone"
    [editable]="false"
    [disabled]="isDisabled"
    placeholder="{{'label.startTyping...' | translate}}"
    [required]="required" />